import { initVirtualvisit } from '@organisms/virtualvisit';
import { eventBus } from '@tools/event-bus';

export const virtualVisit = () => {
  initVirtualvisit();

  document.querySelectorAll('.virtualvisit-launcher').forEach(
    (element) => element.addEventListener(
      'click',
      () => eventBus.dispatchEvent(new Event('virtualvisit-open')),
    ),
  );
};
